(function () {

    function ensureToastRoot() {
  let root = document.getElementById('toast-root');
  if (!root) {
    root = document.createElement('div');
    root.id = 'toast-root';
    document.body.appendChild(root);
  }
  return root;
}
function showToast(message, durationMs = 1500) {
  const root = ensureToastRoot();
  const el = document.createElement('div');
  el.className = 'toast';
  el.textContent = message;
  root.appendChild(el);
  // paint sonra show sınıfını ekle
  requestAnimationFrame(() => el.classList.add('show'));
  // süre sonunda kaldır
  setTimeout(() => {
    el.classList.remove('show');
    setTimeout(() => el.remove(), 300);
  }, durationMs);
}

/* Sayaç elementi bulucu: farklı temalarda farklı selector olabilir */
function findCartCountEl() {
  // Dawn: header'da genelde [data-cart-count]
  return document.querySelector('[data-cart-count]') ||
         document.querySelector('[data-header-cart-count]') ||
         document.querySelector('.cart-count-bubble, .header__icon--cart .cart-count');
}

// function setCartBubbleCount(n) {
//   const root = document.getElementById('cart-icon-bubble');
//   if (!root) return;

//   // span hiyerarşisi: #cart-icon-bubble > a > .cart-count-bubble > span
//   const span =
//     root.querySelector('.cart-count-bubble [data-cart-count]') ||
//     root.querySelector('.cart-count-bubble .cart-count-bubble__count') ||
//     root.querySelector('.cart-count-bubble > span'); // senin yapın

//   if (!span) return;

//   span.textContent = String(n);

//   // 0 iken gizle / >0 iken göster (temana göre sınıf/inline seç)
//   const bubble = root.querySelector('.cart-count-bubble');
//   if (bubble) {
//     if (Number(n) > 0) {
//       bubble.style.display = 'inline-flex';
//       bubble.setAttribute('aria-hidden', 'false');
//       bubble.classList.remove('is-empty');
//     } else {
//       bubble.style.display = 'none';
//       bubble.setAttribute('aria-hidden', 'true');
//       bubble.classList.add('is-empty');
//     }
//   }
// }

function ensureCartBubble() {
  let bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
  if (!bubble) {
    const root = document.getElementById('cart-icon-bubble');
    if (!root) return null;

    bubble = document.createElement('div');
    bubble.className = 'cart-count-bubble';
    bubble.setAttribute('aria-hidden', 'true');
    bubble.style.display = 'none';

    const visible = document.createElement('span');
    visible.setAttribute('aria-hidden', 'true');
    visible.textContent = '0';

    const hidden = document.createElement('span');
    hidden.className = 'visually-hidden';
    hidden.textContent = '0 items';

    bubble.appendChild(visible);
    bubble.appendChild(hidden);

    const link = root.querySelector('a');
    if (link) link.appendChild(bubble);
    else root.appendChild(bubble);
  }
  return bubble;
}

function setCartBubbleCount(n) {
  const bubble = ensureCartBubble();
  if (!bubble) return;

  const visible = bubble.querySelector('span[aria-hidden="true"]');
  const hidden = bubble.querySelector('.visually-hidden');

  if (visible) visible.textContent = n;
  if (hidden) hidden.textContent = n + (n === 1 ? ' item' : ' items'); // erişilebilirlik için

  if (n > 0) {
    bubble.style.display = 'inline-flex';
    bubble.setAttribute('aria-hidden', 'false');
    bubble.classList.remove('is-empty');
  } else {
    bubble.style.display = 'none';
    bubble.setAttribute('aria-hidden', 'true');
    bubble.classList.add('is-empty');
  }
}


function getI18nMessages() {
  try {
    const el = document.getElementById('i18n-messages');
    return el ? JSON.parse(el.textContent) : {};
  } catch { return {}; }
}
const I18N = getI18nMessages();

function t(key, fallback) {
  return (I18N && I18N[key]) || fallback || key;
}

  function sel(root, s){return (root||document).querySelector(s)}
  function all(root, s){return Array.from((root||document).querySelectorAll(s))}

  // Qty +/- (delegation; dinamikte de çalışır)
  document.addEventListener('click', function(e){
    const btn = e.target.closest('.card-inline-atc .qty__btn'); if(!btn) return;
    const wrap = btn.closest('.card-inline-atc'); const input = wrap.querySelector('.qty__input');
    const step = parseInt(btn.getAttribute('data-step'),10)||1;
    const cur = parseInt(input.value,10)||1;
    input.value = Math.max(1, cur + step);
  }, true);

  // Add to cart (no redirect)
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.card-inline-atc .js-add, .card-inline-atc .js-add-subscribe');
  if (!btn) return;

  e.stopPropagation(); // stretched link'e gitmesin
  if (btn.classList.contains('disabled')) return;

  const row = btn.closest('.card-inline-atc');
  const input = row.querySelector('.qty__input');
  const qty = parseInt(input?.value, 10) || 1;
  const variantId = Number(btn.getAttribute('data-variant-id'));
  if (!variantId) return;

  // Abonelik mi?
  const sellingPlan = btn.classList.contains('js-add-subscribe')
    ? Number(btn.getAttribute('data-selling-plan-id') || 0)
    : 0;

  // Payload'ı kur
  // - Tek seferlik: legacy body { id, quantity } veya yeni { items: [...] }
  // - Abonelik: MUTLAKA { items: [{ id, quantity, selling_plan }] }
  const isSubscription = !!sellingPlan;
  const body = isSubscription
    ? { items: [{ id: variantId, quantity: qty, selling_plan: sellingPlan }] }
    : ({ id: variantId, quantity: qty }); // dilersen burada da {items:[{id,quantity}]} kullanabilirsin

  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(body)
  })
  .then(res => {
    return res.json().then(data => {
      if (!res.ok) {
        // Shopify 422 vs. hataları burada gelir (ör. selling_plan unavailable)
        throw new Error(data?.description || data?.message || 'Add failed');
      }
      return data; // 👈 sonraki .then'e item'ı taşı
    });
  })
.then(item => {
  const qtyAdded = (item && item.quantity) ? item.quantity : qty;

  // 1) Optimistic: yoksa balonu oluşturup anında artır
  const current = parseInt(
    (document.querySelector('#cart-icon-bubble .cart-count-bubble > span')?.textContent) || '0',
    10
  ) || 0;
  setCartBubbleCount(current + qtyAdded);

  // 2) Gerçek sepet ile eşitle (ilk üründe özellikle önemli)
  fetch('/cart.js')
    .then(r => r.json())
    .then(c => setCartBubbleCount(c.item_count));

  document.dispatchEvent(new CustomEvent('cart:updated', { detail: item }));
  if (typeof t === 'function' && typeof showToast === 'function') {
    showToast(t('added_to_cart', isSubscription ? 'Subscribed & added' : 'Added to cart'));
  }
})



  .catch(err => {
    console.error(err);
    btn.classList.add('disabled');
    btn.setAttribute('aria-disabled', 'true');
    alert(err.message || 'Sepete ekleme başarısız.');
  })
  .finally(() => {
    btn.disabled = false;
  });
}, true);


  // Theme editor/section reload için ekstra bağlamaya gerek yok (delegation)
})();
